import { useEffect } from "react";
import QRCode from "react-qr-code";
import { useAnimation } from "../hooks/useAnimation";

const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.fiyuu.riders&hl=tr";

const Kurye = () => {
    const animate = useAnimation();

    useEffect(() => {
        animate();
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="kurye-apply">
            <div className="kurye-apply__inner">
                <div
                    className="kurye-apply__visual"
                    data-animation="slideInUp"
                    data-animation-delay="50ms"
                >
                    <img src="/images/jaf-image.png" alt="Fiyuu kuryeleri" />
                </div>

                <div
                    className="kurye-apply__card"
                    data-animation="zoomIn"
                    data-animation-delay="50ms"
                >
                    <h1>Kurye olmak istiyorum</h1>
                    <h2>Başvurular artık mobilde!</h2>
                    <p className="kurye-apply__copy kurye-apply__copy--desktop">
                        Kurye başvuruları şu anda yalnızca Android cihazlar üzerinden alınmaktadır.
                        Devam etmek için Android cihazından aşağıdaki karekodu okutabilirsin.
                    </p>
                    <p className="kurye-apply__copy kurye-apply__copy--mobile">
                        Kurye başvuruları şu anda yalnızca Android cihazlar üzerinden alınmaktadır.
                        Devam etmek için Android cihazından aşağıdaki butona tıklayabilirsin.
                    </p>

                    <div className="kurye-apply__qr">
                        <QRCode
                            value={PLAY_STORE_URL}
                            size={196}
                            level="M"
                            bgColor="#FFFFFF"
                            fgColor="#000000"
                            title="Fiyuu Kurye uygulamasını indirmek için karekod"
                        />
                    </div>

                    <a
                        className="kurye-apply__store"
                        href={PLAY_STORE_URL}
                        aria-label="Google Play'den indirin"
                    >
                        <img src="/images/google-play-badge-tr.png" alt="" />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Kurye;
